import { useNavigate } from 'react-router-dom'
import SEARCHING_SVG from '../../assets/images/svgs/file-searching.svg'

const Error404 = () => {
  const navigate = useNavigate()
  return (
    <div className="row justify-content-center">
        <div className="col-lg-4">
            <div className="text-center">
                <img src={SEARCHING_SVG} height="90" alt="File not found Image"/>

                <h1 className="text-error mt-4">404</h1>
                <h4 className="text-uppercase text-danger mt-3">Page Not Found</h4>
                <p className="text-muted mt-3">It's looking like you may have taken a wrong turn. Don't worry... it
                    happens to the best of us. Here's a
                    little tip that might help you get back on track.</p>

                <span onClick={() => navigate(-1)} className="btn btn-info mt-3"><i className="mdi mdi-reply"></i> Return Home</span>
            </div> 
            {/* <!-- end /.text-center--> */}
        </div> 
        {/* <!-- end col--> */}
    </div>
  )
}

export default Error404